/// <reference types="vite/types/importMeta.d.ts" />

import type { FirebaseApp } from 'firebase/app';
import type { Functions } from 'firebase/functions';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { doc, onSnapshot, getFirestore } from 'firebase/firestore';
import { notification, Button } from 'ant-design-vue';
import { h } from 'vue';
import { useRouter } from 'vue-router';

export function getFbFunctions(fbApp: FirebaseApp, region?: string): Functions {
  // If we're in emulator mode, connect to the local emulator
  const emulatorMode = import.meta.env.VITE_FIREBASE_EMULATOR === 'true';

  if (emulatorMode) {
    const emulatorPort = import.meta.env.VITE_FIREBASE_EMULATOR_PORT || 5004;
    const functions = getFunctions(fbApp);
    console.info('Connecting to Firebase Functions emulator on port', emulatorPort);
    connectFunctionsEmulator(functions, '127.0.0.1', emulatorPort);
    return functions;
  } else {
    return getFunctions(fbApp, region || import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION);
  }
}

export function watchReleaseBuild(fbApp: FirebaseApp) {
  const router = useRouter();
  const db = getFirestore(fbApp, this.dbid);
  return onSnapshot(doc(db, 'system', 'build'), (snap) => {
    const checkDisabled = snap.data()?.checkDisabled || false;
    const remoteVersion = snap.data()?.version;
    if (
      remoteVersion
      && remoteVersion != import.meta.env.VITE_BUILD
      && !checkDisabled
      && import.meta.env.VITE_BUILD !== 'development'
      && router.currentRoute.value.path.startsWith('/app')
    ) {
      window.console.log(
        `A new version of the app is available. Current: ${import.meta.env.VITE_BUILD}, Remote: ${remoteVersion}`,
      );
      notification.open({
        message: 'A new version of the app is available',
        description: () => h(
          'div',
          { style: { whiteSpace: 'pre-line' } },
          { default: () => [
            'Refresh now to view the latest updates and features.',
            h('div', { class: 'mt-2 flex justify-end' },
              { default: () => [
                h(
                  Button,
                  {
                    type: 'primary',
                    onClick: () => window.location.reload(),
                  },
                  { default: () => 'Refresh' },
                ),
              ]},
            ),
          ]},
        ),
        placement: 'bottom',
        key: 'release-build-out-of-date',
        duration: 0,
      });
    }
  });
}
